import {
  IStandardAPIResponse,
  IReadingStatus,
  IDGSetReading,
  ISearchDgSet,
} from "../../vm";
import { httpClient, handleErrorResp } from "../UtilService";

export async function getDgSetReadings(
  obj: ISearchDgSet
): Promise<IStandardAPIResponse<Array<IDGSetReading>>> {
  try {
    let res = await httpClient<Array<IDGSetReading>>(`dg-reading`, "GET", obj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function updateDgSetReadingStatus(
  obj: IReadingStatus
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`dg-reading/status`, "PATCH", obj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateDgSetReading(
  data: IDGSetReading
): Promise<IStandardAPIResponse<IDGSetReading>> {
  try {
    let res = await httpClient<IDGSetReading>(
      `dg-reading/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
